<template>
  <div id="contenedor-titulo-tool-bar">
    <v-toolbar
      flat>
      <div
        v-if="regresar"
        id="titulo-toolbar-btn-regresar">
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="botonRegresar">
              <v-icon>
                fa-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </div>
      <v-toolbar-title
        :class="{
          'ml-6': regresar,
          'display-1': !$vuetify.breakpoint.xs,
          'display-0': $vuetify.breakpoint.xs
          }">
        <span> {{ titulo }} </span>
      </v-toolbar-title>
      <slot
        name="opciones">
      </slot>
      <v-spacer></v-spacer>
      <slot
        name="opciones-derecha">
      </slot>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'TituloToolBar',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    regresar: {
      type: Boolean,
      required: false,
      default: false,
    },
    nombreRuta: {
      type: String,
      required: false,
    },
  },
  methods: {
    botonRegresar() {
      const { regresar, nombreRuta } = this;

      if (regresar && nombreRuta) {
        this.$router.push({ name: nombreRuta });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#titulo-toolbar-btn-regresar {
  position: absolute;
  left: -10px;
  right: 0;
  margin: auto
}
</style>
